import React, { useState } from "react";
import swal from "sweetalert";
import { integrationServiceForm } from "../GameServices/GameServices";

const useIteraion = () => {
  const [fields, setFields] = useState({
    name: "",
    email: "",
    message: "",
  });

  const onSubmit = async () => {
    let data = {
      name: fields.name,
      email: fields.email,
      message: fields.message,
      userId: localStorage.getItem("user_id"),
      origin: "Contact Us",
    };
    let response = await integrationServiceForm(data).then((res) => {
      setFields({
        name: "",
        email: "",
        message: "",
      });
      if (res?.data) {
        swal("Success!", "Response Submitted Successfully!", "success");
      }
    });
  };
  return {
    onSubmit,
    setFields,
    fields,
  };
};

export default useIteraion;
